module.exports = __webpack_public_path__ + "img/公司简介.61bc1afb.png";